<!--我的页面-->
<template>
    <div class="id">
        <div class="navBar" @click="$router.back()">
            <van-icon name="arrow-left" />
            {{ $t('提币') }}
        </div>
        <div class="title"> {{ $t('选择币种') }}</div>
        <div class="universal" @click="showPicker = true">
            <div>{{ currency.text }}</div>
            <van-icon name="arrow-down" />
        </div>
        <div class="title">{{ $t('提现地址') }}</div>
        <div class="universal">
            <van-field v-model="address" :placeholder="$t('请输入提现地址')" :border="false" />
        </div>
        <div class="title">{{ $t('数量') }}</div>
        <div class="universal">
            <van-field v-model="quantity" :placeholder="$t('请输入')" :border="false" @input="inputCk" />
            <div style="color: #07ecfe;white-space: nowrap;" @click="allCk">{{ $t('全部') }}</div>
        </div>
        <div style="padding-top: 8px;color: #999999;">{{ $t('可用') }}：{{ money }} USDT</div>

        <div class="title">{{ $t('手续费') }}</div>
        <div class="universal">
            {{ withdrawFee }} USDT
        </div>
        <div class="title">{{ $t('到账金额') }}</div>
        <div class="universal">
            {{ receipt }}
        </div>
        <div class="title">{{$t('资金密码')}}</div>
        <div class="universal">
            <van-field v-model="pay_password" type="password" :placeholder="$t('请输入')" :border="false"  />
        </div>
        <van-button class="btn" type="primary" @click="carryTb">{{ $t('提币') }}</van-button>

        <!-- <van-image width="100%" src="https://shengge975.com/img/txt.ef7125b5.png" /> -->
        <div class="tipsBack">
            <div style="font-size: 18px;padding-bottom: 20px;">{{ $t('重要通知') }}</div>
            <div v-html="content"></div>
        </div>
        <div class="title">{{ $t('充值记录') }}</div>
        <div class="table">
            <!-- 表头 -->
            <van-row class="header">
                <van-col span="6" class="vanItem">{{ $t('币种') }}</van-col>
                <van-col span="6" class="vanItem">{{ $t('提币金额') }}</van-col>
                <van-col span="6" class="vanItem">{{ $t('状态') }}</van-col>
                <van-col span="6" class="vanItem">{{ $t('创建时间') }}</van-col>
            </van-row>
            <!-- 数据 -->
            <div class="scroll">
                <van-row v-for="item in users" :key="item.id" class="row">
                    <van-col span="6" class="trade">
                        {{ item.payment_name }}
                    </van-col>
                    <van-col span="6" class="trade">
                        {{ item.amount }}
                    </van-col>
                    <van-col span="6" class="trade">
                        {{ item.status_text }}
                    </van-col>
                    <van-col span="6" class="trade">
                        {{ item.createtime_text }}
                    </van-col>
                </van-row>
            </div>
        </div>
        <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" :confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')"/>
        </van-popup>

    </div>
</template>
<script>
import { get, post } from '@/http/request'
import apis from '@/http/api'
export default {
    components: {

    },
    data() {
        return {
            quantity: '',
            receipt: '0',
            showPicker: false,
            columns: [],
            currency: {},
            address: '',
            users: [],
            content: '',
            money: '',
            pay_password: '',
            withdrawFee: ''
        };
    },
    mounted() {
        this.withdrawData()
        this.withdrawList()
        this.addressList()
        this.getUserInfo()
    },
    beforeUnmount() { },
    methods: {
        async withdrawData() {
            const res = await get(apis.withdrawData)
            if (res.code == 1) {
                this.content = res.data.content
                return
            }
        },
        //提现币种
        async addressList() {
            const res = await get(apis.addressList, { limit: 9999 })
            if (res.code == 1) {
                this.columns = res.data.payment.map(item => ({
                    text: item.name,
                    ...item
                }))
                this.currency = this.columns[0]
                return
            }
        },
        //提现记录
        async withdrawList() {
            const res = await get(apis.withdrawList, { limit: 9999, showLoading: false })
            if (res.code == 1) {
                this.users = res.data.data
                return
            }
        },
        //
        async getUserInfo() {
            const res = await get(apis.getUserInfo)
            if (res.code == 1) {
                this.money = res.data.money
                return
            }
        },
        //提币
        async carryTb() {
            const res = await post(apis.withdrawSubmit, { amount: this.quantity, address: this.address, payment_id: this.currency.id, pay_password: this.pay_password })
            if (res.code == 1) {
                this.quantity = ''
                this.$toast(res.msg);
                setTimeout(() => {
                    this.withdrawList()
                }, 1200)
                return
            }

        },
        //全部
        allCk() {
            this.quantity = this.money
            this.withdrawFee = this.quantity * this.currency.withdraw_fee
            this.receipt = (this.quantity - this.withdrawFee) / this.currency.rate
        },
        //shuru jine 
        inputCk() {
            this.withdrawFee = this.quantity * this.currency.withdraw_fee
            this.receipt = (this.quantity - this.withdrawFee) / this.currency.rate
            // currency.withdraw_fee
        },

        onConfirm(value) {
            this.currency = value
            this.withdrawFee = this.quantity * this.currency.withdraw_fee
            this.receipt = (this.quantity - this.withdrawFee) / this.currency.rate
            this.showPicker = false
        },
    },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell {
    padding: 0;
}

.id {
    color: #fff;
    padding: 0 15px;
    padding-bottom: 20px;
    padding-top: 50px;
    font-size: 14px;

    .navBar {
        background-color: #090d13;
        padding: 15px 10px;
        font-size: 18px;
        font-weight: 700;
        border-radius: 4px;
    }

    .title {
        padding-top: 20px;
        font-size: 16px;
        font-weight: 700;
    }

    .btn {
        width: 100%;
        margin: 20px 0;
        background-color: #07ecfe;
        border-radius: 5px;
        color: #000;
    }

    .table {
        background: #000;
        color: #fff;
        margin-top: 20px;
        font-size: 12px;

        .header {
            background: #1c222c;
            padding: 10px 0;
            border-radius: 5px;

            .vanItem {
                text-align: center;
            }
        }

        .scroll {
            overflow-y: auto;
            height: 45vh;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            /* IE/Edge */
        }

        .row {
            border-bottom: 1px solid #222b39;
            padding: 10px 0px;
            display: flex;
            align-items: center;
            font-size: 11px;

            .trade {
                text-align: center;
            }
        }
    }

    .tipsBack {
        background-color: #171d28;
        padding: 20px;
        border-radius: 10px;
        margin-top: 30px;
    }

    .universal {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #3a3f47;
        margin-top: 10px;
        border-radius: 5px;

        .address {
            width: 85%;
            word-break: break-all;
        }
    }

}
</style>
